<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-24 col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('youWillReceiveReportsFromCommunity')"
            >
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
            <router-link
              to="/register"
              class="btn btn-outline mb-3 min-h d-none d-md-flex"
              v-text="$ml.get('iWantToCreateAnAccount')"
            >
              Quero criar uma conta!
            </router-link>
          </div>
          <div
            class="col-2 min-h d-none d-md-flex justify-content-center py-3 mb-5"
          >
            <span class="line align-self-center"></span>
          </div>

          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-if="registerAccountSSO" v-text="$ml.get('letsCompleteYourRegistration')">
                  Vamos concluir seu cadastro!
                </h5>
                <h5 v-else v-text="$ml.get('letsCreateYourPreRegistration')">
                  Vamos criar seu pré-cadastro!
                </h5>
                <p v-if="registerAccountSSO" v-text="$ml.get('titleRegisterAccountSSO')">
                    É simples, não leva nem 1 minuto. Confirme alguns dados e estará concluído em instantes.
                </p>
                <p v-else v-text="$ml.get('superSimpleItDoesntEvenTakeCompany')">
                  Super simples, não leva nem 1 minuto. Basta informar os dados
                  comuns da organização e pronto, sua conta será enviada para
                  análise.
                </p>
                <transition name="fade">
                  <div v-show="msgdanger" class="alert alert-danger">
                    {{ msgdanger }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgWarning" class="alert alert-warning">
                    {{ msgWarning }}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="registerAccountSSO && !emailSSO"  class="alert alert-warning">
                    {{$ml.get('attributeEmailSSO')}}
                  </div>
                </transition>
                <transition name="fade">
                  <div v-show="msgSuccess" class="alert alert-success">
                    <font>{{ registerAccountSSO ?  $ml.get('user') : $ml.get('company') }}</font>&nbsp;
                    <strong v-text="msgSuccess"></strong>&nbsp;
                    <font v-text="$ml.get('successfullyCreated')"
                      >&nbsp;criada com sucesso</font
                    >!,
                    <font v-text="$ml.get('youWillBeRedirectedIn')"
                      >Você será redirecionado em</font
                    >
                    {{ seconds }}
                    <font v-text="$ml.get('seconds')">segundos</font>.
                  </div>
                </transition>

                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <input v-if="emailSSO" type="text" class="form-control" v-model="emailSSO" :disabled="true">
                    </div>
                    <div class="form-group">                     
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="registerAccountSSO ? $ml.get('yourName') : $ml.get('YourOrganizationTradeName')"
                        v-model="name"
                        aria-modal="100"
                      />
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.name.required"
                        class="lblError"
                        v-text="$ml.get('yourOrganizationNameIsRequired')"
                        >Nome de sua organização é obrigatório</label
                      >
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.name.regexRSC"
                        class="lblError"
                        v-text="$ml.get('cannotEnterSpecialCharacters')"
                        >Não é possível inserir caracteres especiais</label
                      >
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.name.minLength && $v.name.regexRSC"
                        class="lblError"
                        v-text="
                          $ml
                            .with('f', $v.name.$params.minLength.min)
                            .with('l', 100)
                            .get('theNameMustBeFromToCharacters')
                        "
                        >É preciso ter pelo menos caracteres.</label
                      >
                    </div>
                  </div>
                </div>

                <div class="row" v-if="!registerAccountSSO">
                  <div class="col">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="contactName"
                        :placeholder="$ml.get('nameOfAccountHolder')"
                        maxlength="100"
                      />
                      <label
                        v-if="
                          submitStatus === 'ERROR' && !$v.contactName.required
                        "
                        class="lblError"
                        v-text="
                          $ml.get('theNameOfThePersonResponsibleIsMandatory')
                        "
                        >Nome do responsável é obrigatório</label
                      >
                      <label
                        v-if="
                          submitStatus === 'ERROR' && !$v.contactName.regexOTN
                        "
                        class="lblError"
                        v-text="$ml.get('cannotEnterSpecialCharacters')"
                        >Não é possível inserir caracteres especiais</label
                      >
                      <label
                        v-if="
                          submitStatus === 'ERROR' && !$v.contactName.minLength
                        "
                        class="lblError"
                        v-text="
                          $ml
                            .with('f', $v.contactName.$params.minLength.min)
                            .with('l', 100)
                            .get('theNameMustBeFromToCharacters')
                        "
                        >É preciso ter pelo menos caracteres.</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <the-mask
                        class="form-control"
                        v-model="phone"
                        :mask="['(##) ####-####', '(##) #####-####']"
                        :placeholder="$ml.get('yourPhoneToGetInTouch')"
                      />
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.phone.required"
                        class="lblError"
                        v-text="$ml.get('informThePhoneWithAreaCode')"
                        >Informe o telefone com DDD</label
                      >
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.phone.minLength"
                        class="lblError"
                        v-text="$ml.get('informThePhoneWithAreaCode')"
                        >Informe o telefone com DDD</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group" v-if="!emailSSO && !registerAccountSSO">
                      <input
                        type="text"
                        class="form-control"
                        v-model="email"
                        :placeholder="$ml.get('enterYourPrimaryEmailAddress')"
                        maxlength="100"
                      />
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.email.required"
                        class="lblError"
                        v-text="$ml.get('enterTheEmail')"
                        >Informe o e-mail primario</label
                      >
                      <label
                        v-if="submitStatus === 'ERROR' && !$v.email.email"
                        class="lblError"
                        v-text="$ml.get('emailDoesNotAppearToBeValid')"
                        >Este e-mail não parece estar válido</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!registerAccountSSO">
                  <div class="col">
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control"
                        v-model="password"
                        :placeholder="$ml.get('aSuperStrongPasswordNow')"
                        maxlength="200"
                      />
                      <transition v-if="submitStatus" name="fade">
                        <label class="lblError">{{
                          passwordValidation.errorsString
                        }}</label>
                      </transition>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!registerAccountSSO">
                  <div class="col">
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control"
                        v-model="passwordConfirm"
                        :placeholder="$ml.get('confirmYourPassword')"
                        maxlength="200"
                      />
                      <transition name="fade">
                        <label
                          class="lblError"
                          v-if="submitStatus && !$v.passwordConfirm.required"
                          v-text="$ml.get('enterPasswordConfirmation')"
                          >Digite a confirmação de senha</label
                        >
                        <label
                          class="lblError"
                          v-if="
                            submitStatus && !$v.passwordConfirm.sameAsPassword
                          "
                          v-text="$ml.get('passwordsMustMatch')"
                          >As senhas devem ser iguais!</label
                        >
                      </transition>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <multiselect
                      v-model="optionSelected"
                      :options="itensSituation"
                      :searchable="true"
                      :placeholder="$ml.get('selectCountry')"
                      label="name"
                      :custom-label="nameLang"
                      :close-on-select="true"
                      :show-labels="false"
                      :allow-empty="false"
                      :preselect-first="true"
                      :multiple="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="custom-checkbox">
                  <input
                    type="checkbox"
                    id="checkTerms"
                    v-model="checkTerms"
                    name="check"
                  />
                  <label class="form-check-label label-text" for="checkTerms">
                    <font class="m-4">
                      <font>{{ $ml.get('iAgreeWithThe') }}</font>
                      <a
                        href="https://www.bughunt.com.br/termos-de-uso.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ $ml.get('termsOfUse') }}
                      </a>
                      {{ $ml.get('and') }}
                      <a
                        href="https://bughunt.com.br/codigo-de-conduta.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $ml.get('codeOfConduct') }}</a
                      >.
                    </font>
                  </label>
                </div>
                <transition name="fade">
                  <label v-if="submitStatus && !checkTerms" class="lblError">
                    {{
                      $ml.get('youMustAgreeToTheTermsOfUseAndCodeOfConduct')
                    }}</label
                  >
                </transition>

                <div class="d-flex justify-content-center mt-3">
                  <RecaptchaV2 ref="recaptcha" @verify="setRecaptchaToken" @expired="tokenRecaptcha = ''"/>
                </div>

                <div class="row mt-2 mb-2">
                  <div class="col-auto w-100">
                    <button
                      :disabled="loadingBtn || !tokenRecaptcha"
                      @click="registerAccountSSO ? createSSOAccount() : registerAccount()"
                      class="btn btnForm mr-2 mt-2"
                    >
                      <Spinner v-show="loadingBtn" />
                      <span
                        v-show="!loadingBtn"
                        v-text="$ml.get('createMyAccount')"
                      >
                        Criar minha conta!</span
                      >
                    </button>
                    <router-link
                      to="/login"
                      class="btn btnForm btn-outline-extra mt-2"
                      v-text="$ml.get('iAlreadyHaveAnSccount')"
                    >
                      Eu já tenho conta!
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import RecaptchaV2 from '../../components/recaptchaV2.vue';
import { utils } from '../../utils';
import Translate from '../../components/translate.vue';
import { listCountries } from '../../helpers/mocks';
import { mapActions } from "vuex";
const regexOTN = utils.regexCheck('OTN');
const regexRSC = utils.regexCheck('RSC');

export default {
  components: {
    RecaptchaV2,
    Translate,
  },
  page: {
    title: 'Cadastro',
    meta: [{ name: 'description' }],
  },
  data() {
    return {
      name: '',
      contactName: '',
      phone: '',
      email: '',
      password: '',
      passwordConfirm: '',
      seconds: 5,
      loadingBtn: false,
      checkTerms: false,
      submitStatus: null,
      msgdanger: '',
      msgWarning: '',
      msgSuccess: '',

      rules: [
        { message: 'aNumber', regex: /[0-9]+/ },
        { message: 'anUppercaseLetter', regex: /[A-Z]+/ },
        { message: 'aLowercaseLetter', regex: /[a-z]+/ },
        { message: 'atLeastCharacters', regex: /.{6,}/ },
      ],

      optionSelected: {
        name: 'brasil',
        value: 'br',
      },
      itensSituation: listCountries,
      tokenRecaptcha: '',
      registerAccountSSO: "",
      token: "",
      emailSSO:"",
    };
  },
  validations: {
    name: { required, regexRSC, minLength: minLength(3) },
    contactName: { required, regexOTN, minLength: minLength(3) },
    phone: { required, minLength: minLength(10) },
    email: { required, email },
    passwordConfirm: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  computed: {
    passwordValidation() {
      const errors = [];

      for (let condition of this.rules) {
        if (!condition.regex.test(this.password)) {
          errors.push(this.$ml.get(condition.message));
        }
      }
      let errorsString = '';

      if (errors.length) {
        errorsString = `${this.$ml.get('thePasswordMustHave')}, ${errors.join(', ')}`;
      } else {
        errorsString = '';
      }

      return { errorsString };
    },

    preferredLanguage() {
      if (this.$ml.current == 'english') {
        return 'en';
      } else if (this.$ml.current == 'spanish') {
        return 'es';
      }
      return 'pt';
    },
  },
  beforeMount(){
    this.registerAccountSSO = this.$route.query?.register;
    this.token = this.$route.query?.token;
    this.emailSSO = this.$route.query?.email;
  },
  mounted() {
    this.$v.$reset();
  },
  methods: {
    ...mapActions([
      "setUser",
      "setAmountPrograms",
      "setCanAccessExtApi",
      "setTermsUseConduct",
      "setAmountPentests"
    ]),
    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },

    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },

    registerAccount() {
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        !this.checkTerms ||
        this.passwordValidation.errorsString
      ) {
        this.submitStatus = 'ERROR';
        return;
      }

      var self = this;
      this.loadingBtn = true;
      this.msgdanger = '';
      this.msgWarning = '';
      this.msgSuccess = '';

      delete axios.defaults.headers.common['Authorization'];
      axios
        .post(this.$store.getters['getApiUrl'] + `company`, {
          name: self.name,
          contactName: self.contactName,
          phone: {
            areaCode: self.phone.substr(0, 2),
            number: self.phone.substr(2, 11),
          },
          email: self.email,
          password: self.password,
          tokenRecaptcha: this.tokenRecaptcha,
          language: self.preferredLanguage,
          country: self.optionSelected.value,
          termsUseConduct: this.checkTerms,
        })
        .then(function () {
          self.msgSuccess = self.name;
          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              self.loadingBtn = false;
              self.$router.push({
                name: 'login',
                params: {
                  email: self.email,
                },
              });
              clearInterval(refreshInterval);
            }
          }, 1000);
        })
        .catch(function (error) {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;
          if (error.response.status == 404) {
            self.msgdanger = self.$ml.get('unableToCompleteThisRequest');
            return;
          }
          if (error.response.status == 400 && error.response.data.message === 'Nome de empresa já cadastrado') {
            self.msgWarning = self.$ml.get('companyNameAlreadyRegisteredInOurDatabase');
            return;
          }
          if (error.response.status == 400) {
            self.msgWarning = self.$ml.get(
              'emailAlreadyRegisteredInOurDatabase'
            );
            return;
          }
          if (error.response.data.statusCode == 425) {
            self.msgWarning = self.$ml.get('unableToCompleteThisRequest');
            return;
          }
          if (error.response.status == 422) {
            self.msgWarning = self.$ml.get('theTokenMustBeEntered');
          }
        });
    },
    async createSSOAccount() {
      this.$v.$touch();
      if (
        this.$v.name.$invalid || 
        this.$v.phone.$invalid || 
        !this.checkTerms 
      ) {
        this.submitStatus = 'ERROR';
        return;
      }

      var self = this;
      this.loadingBtn = true;
      this.msgdanger = '';
      this.msgWarning = '';
      this.msgSuccess = '';

      delete axios.defaults.headers.common['Authorization'];

      try {
        const payload = {
          name: this.name,
          phone: {
            areaCode: this.phone.substr(0, 2),
            number: this.phone.substr(2, 11),
          },
          tokenRecaptcha: this.tokenRecaptcha,
          language: this.preferredLanguage,
          country: this.optionSelected.value,
          termsUseConduct: this.checkTerms,
        };

        const config = {
          headers: {
            Authorization: this.token,
          },
        };

      const {data, status} = await axios.post(
          this.$store.getters['getApiUrl'] + `account/sso/company-member`,
          payload,
          config
        );

        if (status == 201) {
          const { access_token } = data;
          var decodedStr = JSON.parse(atob(access_token.split(".")[1]));
          self.setTermsUseConduct(decodedStr.termsUseConduct);       
          self.msgSuccess = self.name;
          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
             self.getDados(access_token, decodedStr.roles[0]);
              self.loadingBtn = false;
              clearInterval(refreshInterval);
            }
          }, 1000);

        }

      } catch (error) {
        this.$refs.recaptcha.resetRecaptcha();
        this.tokenRecaptcha = "";
        this.loadingBtn = false;

        if (error.response) {
          const status = error.response.status;
          const statusCode = error.response.data?.statusCode;

          if (status === 404) {
            this.msgdanger = this.$ml.get('unableToCompleteThisRequest');
          } else if (status === 400) {
            this.msgWarning = this.$ml.get(
              'emailAlreadyRegisteredInOurDatabase'
            );
          } else if (statusCode === 425) {
            this.msgWarning = this.$ml.get('unableToCompleteThisRequest');
          } else if (status === 422) {
            this.msgWarning = this.$ml.get('theTokenMustBeEntered');
          }
        }
      }
    },

    async getDados(token, type) {
      var self = this;

      axios
        .get(this.$store.getters["getApiUrl"] + `account/my`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (response) => {
          self.setUser({
            token: token,
            type: type,
            account_avatar: response.data.account_avatar,
            company_avatar: response.data?.company_avatar,
            name: response.data.name,
            email: response.data.email,
            companyName: response.data?.companyName,
            username: response.data?.username,
            verified: response.data?.verified,
            paypal_account: response.data?.paypal_account,
            amount_of_reports: response.data?.amount_of_reports,
            score: response.data?.score,
            role: response.data?.role,
            plan: response.data.plan,
            company_createdAt: response.data.company_createdAt,
            account_createdAt: response.data.account_createdAt,
            two_factor_auth_login: response.data.two_factor_auth_login,
            email_code_required: response.data.email_code_required,
            lockerPassword: response.data.lockerPassword,
          });
          if (type == "company") {
            self.setAmountPrograms(response.data.amount_of_programs);
            self.setCanAccessExtApi(response.data.plan.can_access_ext_api);
            self.setAmountPentests(response.data.amount_of_pentests);

            self.setUser({
              two_factor_auth_required:
                response.data.settings.two_factor_auth_required,
              currency: response.data.settings.currency,
              lockerSettings: response.data.lockerSettings,
            });
            const two_factor_auth_required =
              response.data.settings.two_factor_auth_required;
            const two_factor_auth_login = response.data.two_factor_auth_login;
            if (two_factor_auth_required && !two_factor_auth_login) {
              this.$router.push({
                name: "account",
                params: { authentication: "authentication" },
              });
              return;
            }
          }
          if (this.$store.getters["getRouteTo"]) {
            let to = this.$store.getters["getRouteTo"];
            this.$store.dispatch("setRouteTo", "");
            window.location.replace(to);
            return;
          }

          window.location.replace("/dashboard");
        });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.lblError {
  font-size: 11px;
  padding-left: 5px;
  color: red;
  position: absolute;
}
.form-group {
  margin-bottom: 20px;
}
/*General style*/
.form-check-label {
  cursor: pointer;
  color: #666;
  font-size: 15px;
  margin-left: -12px;
}

/*Custom checkboxes style*/
.custom-checkbox input[type='checkbox'] + .label-text:before {
  content: '';
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type='checkbox']:checked + .label-text:before {
  content: '✓';
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}

@keyframes effect {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.3);
  }
  75% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
